import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { FiDollarSign, FiClock, FiPercent } from "react-icons/fi";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout";
import "../../../assets/css/admin/screens/topup/AdminTopupManagement.css";
import AppContext from "../../../contexts/AppContext";
import { Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EarningsManagement = () => {
  const { baseUrl, baseUrlForFiles, adminAuthToken } = useContext(AppContext);
  const [topupStats, setTopupStats] = useState(null);
  const [topups, setTopups] = useState([]);
  const [searchId, setSearchId] = useState("");
  const [sellerStats, setSellerStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState({});
  const [modal, setModal] = useState({ open: false, url: "", shopName: "" });

  const viewAllTopUps = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/topups/viewAllTopUps` ,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminAuthToken}`,
          },
      })
      .then((response) => {
        setTopups(response.data.topups);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const updateStatus = (id, status) => {
    setActionLoading((prev) => ({ ...prev, [id]: true }));
    axios
      .post(
        `${baseUrl}/admin/topups/${status === "approved" ? "approveTopUp" : "rejectTopUp"}`,
        { topup_id: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminAuthToken}`,
          },
        }
      )
      .then(() => {
        toast.success(`TopUp ${status} successfully`);
        viewAllTopUps();
        viewTopUpStats();
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong");
      })
      .finally(() => {
        setActionLoading((prev) => ({ ...prev, [id]: false }));
      });
  };

  const openModal = (file, shopName) =>
    setModal({ open: true, url: `${baseUrlForFiles}/${file}`, shopName });
  const closeModal = () => setModal({ open: false, url: "", shopName: "" });

  const statusBadge = (status) => {
    if (!status) return <span className="ea-status">—</span>;
    const map = {
      approved: "ea-status ea-status-approved",
      pending: "ea-status ea-status-pending",
      rejected: "ea-status ea-status-rejected",
    };
    return (
      <span className={map[status] ?? "ea-status"}>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    );
  };
  const viewTopUpStats = () => {
    axios
      .get(`${baseUrl}/admin/topups/stats` ,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminAuthToken}`,
          },
      })
      .then((response) => {
        setTopupStats(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const searchSeller = () => {
    if (!searchId.trim()) {
      toast.error("Please enter Seller ID");
      return;
    }
    axios
      .get(`${baseUrl}/admin/sellers/getSellerStats`, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminAuthToken}`,
          },
      },
      {
        params: { seller_id: searchId },
      })
      .then((response) => {
        setSellerStats(response.data);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Seller not found");
        setSellerStats(null);
      });
  };
  useEffect(() => {
    viewAllTopUps();
    viewTopUpStats();
  }, []);

  return (
    <AdminMasterLayout>
      <div className="ad-shell">
        <main className="ad-main">
          <section className="ad-card-shell">
            {/* Header */}
            <div className="cm-header-section">
              <div>
                <h3 className="ad-section-title">TopUp & Wallet Management</h3>
                <p className="cm-section-subtitle">
                  Review and approve seller wallet topup requests
                </p>
              </div>
            </div>

            {/* Summary Cards */}
            <div className="ea-summary-grid">
              <div className="ea-summary-card">
                <span className="ea-label">Total Approved TopUp</span>
                <h3>
                  Rs{" "}
                  {Number(
                    topupStats?.total_approved_topups ?? 0,
                  ).toLocaleString()}
                </h3>
                <p className="ea-muted">Approved topups (after commission)</p>
                <div className="ea-summary-icon">
                  <FiDollarSign />
                </div>
              </div>
              <div className="ea-summary-card">
                <span className="ea-label">Pending Requests</span>
                <h3>{topupStats?.pending_topups ?? 0} </h3>
                <p className="ea-muted">Awaiting your approval</p>
                <div className="ea-summary-icon">
                  <FiClock />
                </div>
              </div>
              <div className="ea-summary-card">
                <span className="ea-label">Total Commission Earned</span>
                <h3>
                  Rs{" "}
                  {Number(topupStats?.total_commission ?? 0).toLocaleString()}
                </h3>
                <p className="ea-muted">7% deducted per order</p>
                <div className="ea-summary-icon ea-summary-icon-green">
                  <FiPercent />
                </div>
              </div>
            </div>

            {/* Seller Search */}
            <div className="ea-search-section">
              <h4 className="ea-subtitle">Search Seller</h4>
              <div className="ea-search-row">
                <input
                  className="ea-search-input"
                  type="text"
                  placeholder="Enter Seller ID..."
                  value={searchId}
                  onChange={(e) => setSearchId(e.target.value)}
                />
               <button className="ea-search-btn" onClick={searchSeller}>
  Search
</button>
              </div>

              {sellerStats && (
                <div className="ea-seller-result">
                  <div className="ea-seller-card">
                    <span className="ea-label">Store Name</span>
                    <h4>{sellerStats.store_name}</h4>
                  </div>
                  <div className="ea-seller-card">
                    <span className="ea-label">Total Orders</span>
                    <h4>{sellerStats.total_orders}</h4>
                  </div>
                  <div className="ea-seller-card">
                    <span className="ea-label">Total Earnings</span>
                    <h4>
                      Rs {Number(sellerStats.total_earnings).toLocaleString()}
                    </h4>
                  </div>
                  <div className="ea-seller-card">
                    <span className="ea-label">Commission Paid</span>
                    <h4>
                      Rs {Number(sellerStats.commission_paid).toLocaleString()}
                    </h4>
                  </div>
                  <div className="ea-seller-card">
                    <span className="ea-label">Wallet Balance</span>
                    <h4>
                      Rs {Number(sellerStats.wallet_balance).toLocaleString()}
                    </h4>
                  </div>
                </div>
              )}
            </div>
            {/* Table */}
            <div className="ea-layout">
              <div className="ea-left">
                <h4 className="ea-subtitle">
                  Seller TopUp Requests
                  {topupStats?.pending_topups > 0 && (
                    <span className="ea-subtitle-hint">
                      ({topupStats.pending_topups} pending)
                    </span>
                  )}
                </h4>

                <div className="ea-table-wrapper">
                  <table className="ea-table">
                    <thead>
                      <tr>
                        <th>Topup ID</th>
                        <th>Seller ID</th>
                        <th>Amount </th>
                        <th>Screenshot</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Loading */}
                      {loading && (
                        <tr>
                          <td colSpan="7" className="text-center py-4">
                            <Spinner animation="border" size="sm" />
                            <span className="ms-2 ea-muted">Loading...</span>
                          </td>
                        </tr>
                      )}

                      {/* Rows */}
                      {!loading &&
                        topups.map((t, i) => (
                          <tr key={t.id}>
                            <td>{i + 1}</td>
                            <td className="ea-mono">{t.seller_id ?? "—"}</td>
                            <td className="ea-amount">
                              Rs {Number(t.amount).toLocaleString()}
                            </td>
                            <td>
                              <button
                                className="ea-view-btn"
                                onClick={() =>
                                  openModal(
                                    t.screenshot,
                                    t.seller?.store_name ?? "Seller",
                                  )
                                }
                              >
                                View Screenshot
                              </button>
                            </td>
                            <td className="ea-date">
                              {new Date(t.created_at).toLocaleDateString(
                                "en-US",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )}
                            </td>
                            <td>{statusBadge(t.status)}</td>
                            <td>
                              {t.status === "pending" ? (
                                <div className="ea-action-group">
                                  <button
                                    className="btn-approve-sm"
                                    onClick={() =>
                                      updateStatus(t.id, "approved")
                                    }
                                    disabled={!!actionLoading[t.id]}
                                  >
                                    {actionLoading[t.id] ? "..." : "Approve"}
                                  </button>
                                  <button
                                    className="btn-reject-sm"
                                    onClick={() =>
                                      updateStatus(t.id, "rejected")
                                    }
                                    disabled={!!actionLoading[t.id]}
                                  >
                                    {actionLoading[t.id] ? "..." : "Reject"}
                                  </button>
                                </div>
                              ) : (
                                <span className="ea-no-action">—</span>
                              )}
                            </td>
                          </tr>
                        ))}

                      {/* Empty */}
                      {!loading && topups.length === 0 && (
                        <tr>
                          <td colSpan="7" className="text-center py-5">
                            <div style={{ fontSize: "2rem" }}>💳</div>
                            <p className="ea-muted mt-2">
                              No TopUp requests found
                            </p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>

      {/* Screenshot Modal */}
      {modal.open && (
        <div className="ea-modal-overlay" onClick={closeModal}>
          <div className="ea-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ea-modal-header">
              <div>
                <h4 className="ea-modal-title">Payment Screenshot</h4>
                <p className="ea-modal-shop">{modal.shopName}</p>
              </div>
              <button className="ea-modal-close" onClick={closeModal}>
                ✕
              </button>
            </div>

            <div className="ea-modal-body">
              <img
                src={modal.url}
                alt="Payment proof"
                className="ea-modal-img"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
              <div className="ea-modal-fallback" style={{ display: "none" }}>
                <span>Image could not be loaded</span>
                <a
                  href={modal.url}
                  target="_blank"
                  rel="noreferrer"
                  className="ea-modal-link"
                >
                  Open in new tab →
                </a>
              </div>
            </div>

            <div className="ea-modal-footer">
              <a
                href={modal.url}
                target="_blank"
                rel="noreferrer"
                className="ea-modal-open-btn"
              >
                Open Full Size
              </a>
              <button className="ea-modal-close-btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </AdminMasterLayout>
  );
};

export default EarningsManagement;
